export const errorCodes = {
  unknown: {
    type: 'global',
    text: 'Something went wrong. Please try again later.',
    description: 'unknown',
  },
  443107: {
    type: 'local',
    description: 'Invalid phoneNumber parameter',
    text: 'Check if the country and phone are correct number. We may not yet support your country.',
  },
  510: {
    type: 'ignore',
    description: 'Failed to fetch',
  },
};

export const checkError = (action, name) => {
  if (action.error && action.error.message) {
    console.warn(action.error.message, errorCodes[action.error.message]);
    if (errorCodes[action.error.message]) {
      return errorCodes[action.error.message];
    }
  }
  return errorCodes.unknown;
};
